###
Advanced pricing directive
###
angular
	.module 'App.Directive'
	.directive 'advancedPricing', ->
		restrict: 'EA',
		require: 'ngModel'
		scope:
			product: '<ngModel'
			isProduct: '<?'
			priceRegions: '<'
			vatRates: '='
			parent: '<?'
			callback: '&?'
			hasVariablePrice: '<?'
			isNewEntity: '<'
			isVatRateEnabled: '<?'
			isCostPriceEnabled: '<?'
		controller: 'AdvancedPricingController'
		controllerAs: 'advancedPricing'
		bindToController: true
		link: ($scope, $elem) ->
			$elem.on 'click', $scope.showModal

class AdvancedPricingController extends BaseController
	@register angular.module 'App.Directive'
	@inject '$scope',
		'$filter'
		'$uibModal'
		'translate'
		'ConfigurationService'
		'parseBool'
		'DEFAULT_PRODUCT_DATA_LABEL'
		'BACKEND_PRODUCT_DATA_ENTITY_TYPE'

	initialize: ->
		@modalInstance = null
		@productData = []
		@isCostPriceRecalculationEnabled = @ConfigurationService.isEnabled(
			'Backoffice.Setting.RecalculateCostPriceOnPurchaseOrder.Enabled'
		)
		@isCostPriceEditingEnabled = @ConfigurationService.isEnabled(
			'Shared.Setting.Product.CostPriceEditing.Enabled'
		)
		@isRetailPriceEditingEnabled = @ConfigurationService.isEnabled(
			'Shared.Setting.Product.RetailPriceEditing.Enabled'
		)
		@isOriginalPriceEnabled = @ConfigurationService.isEnabled(
			'Shared.Setting.Product.OriginalPrice.Enabled'
		)
		@isVatRateEnabled ?= @ConfigurationService.isEnabled('Shared.Setting.VatRate.Enabled')

		@initVars()

	initVars: ->
		@isCostPriceEnabled ?= true
		@hasVariablePrice = @parseBool @hasVariablePrice
		@pricingForm = {}
		@defaultEntityType = @BACKEND_PRODUCT_DATA_ENTITY_TYPE.PRODUCT_DATA
		@initActivePriceRegion()
		@groupPriceRegions()
		@currentProductData = []

		if @isVatRateEnabled
			@vatRates = angular.copy(@vatRates)

			for vatRate in @vatRates
				vatRate.displayName = @$filter('number')(vatRate.percentage * 100, 2) + "% [#{vatRate.name}]"

	initActivePriceRegion: ->
		priceRegionMap = _.indexBy(@priceRegions, 'id')

		for productData in @product.product_data
			if priceRegionMap[productData.price_region_id]?
				@currentPriceRegionWithPriceId = productData.price_region_id
				@selectPriceRegionGroup(true)

				return

		@currentPriceRegionWithoutPriceId = @priceRegions[0].id
		@selectPriceRegionGroup(false)

	getProductDataTypes: ->
		if @ConfigurationService.isEnabled 'Backoffice.ProductManagement.Products.EnableDifferentToStayToGo'
			types = @BACKEND_PRODUCT_DATA_ENTITY_TYPE
		else
			types = {
				PRODUCT_DATA: @BACKEND_PRODUCT_DATA_ENTITY_TYPE.PRODUCT_DATA
			}

		productDataTypes = []

		for label in _.values(types)
			if label == @BACKEND_PRODUCT_DATA_ENTITY_TYPE.TO_STAY
				continue

			productDataTypes.push({
				name: @translate(label).toString()
				entity_type: label
			})

		return productDataTypes

	showModal: ->
		@parentPlaceholders = null

		do @initVars
		do @setProductDataCopy
		do @setCurrentProductData

		@modalInstance = @$uibModal.open
			templateUrl: '@directive/advanced-pricing/modals/advanced-pricing.modal.view.html',
			scope: @$scope
			size: 'lg'

	closeModal: (state) ->
		if state
			if @pricingForm.$invalid
				return

			do @matchBackProductData
			@product.product_data = @productData
			@modalInstance.close true

			@callback?()

			return

		@modalInstance.close false

	# Work with copy and only on confirmation set product_data on product to allow cancellation
	setProductDataCopy: ->
		@productData = angular.copy @product.product_data

		for productDataItem in @productData
			productDataItem.entity_type = @defaultEntityType if productDataItem.entity_type == null

	calculateGrossMargins: ->
		defaultCostPrice = @getDefaultCostPrice()

		angular.forEach @currentProductData, (productData) =>
			if productData.data
				productData.grossMargin = @getGrossMargin(productData.data, defaultCostPrice)
			else
				productData.grossMargin = null

	getDefaultCostPrice: ->
		productData = @getCurrentProductDataItems(true)
		defaultProductData = @getDefaultProductDataForPriceRegion(productData, @currentPriceRegionId)

		if defaultProductData?.cost_price?
			return parseInt(defaultProductData.cost_price)

		if !@parent?
			return 0

		productData = @parent.product_data
		defaultProductData = @getDefaultProductDataForPriceRegion(productData, @currentPriceRegionId)

		return parseInt(defaultProductData?.cost_price ? 0)

	getGrossMargin: (productData, defaultCostPrice) ->
		if productData.cost_price
			costPrice = parseInt(productData.cost_price)
		else
			costPrice = defaultCostPrice

		if !parseInt(productData.retail_price || 0) or @hasVariablePrice
			return null

		costPrice = parseFloat(costPrice)
		retailPrice = parseFloat(productData.retail_price)

		retailExcludingTax = retailPrice / (@getProductVatRate(productData) + 1)
		profit = retailExcludingTax - costPrice
		grossMargin = profit / retailExcludingTax * 100

		return grossMargin

	getProductVatRate: (productData) ->
		currentPriceRegion = _.find @priceRegions, {id: @currentPriceRegionId}

		if currentPriceRegion.default_vat_rate_id?
			if productData.vat_rate_id?
				vatRateId = productData.vat_rate_id
			else
				vatRateId = currentPriceRegion.default_vat_rate_id
		else
			return 0

		vatRateId = _.find @vatRates, {id: vatRateId}

		if !_.isEmpty vatRateId
			return parseFloat(vatRateId.percentage)
		else
			return 0

	setPlaceholders: ->
		currentPlaceholders = @getCurrentPlaceholders()
		parentPlaceholders = @getParentPlaceholders()

		@placeholders =
			costPrice: @getPlaceholderForPrice currentPlaceholders, parentPlaceholders, 'cost_price'
			retailPrice: @getPlaceholderForPrice currentPlaceholders, parentPlaceholders, 'retail_price'

	getPlaceholderForPrice: (currentPlaceholders, parentPlaceholders, priceType) ->
		return @$filter('format')(currentPlaceholders[priceType]) if currentPlaceholders[priceType]
		return @$filter('format')(parentPlaceholders[priceType]) if parentPlaceholders[priceType]
		return @translate('wbo.product.' + priceType).toString()

	getEmptyPlaceholders: ->
		return {
			cost_price: null
			retail_price: null
		}

	getPlaceholdersForPriceRegion: (productData, priceRegionId) ->
		defaultProductData = @getDefaultProductDataForPriceRegion productData, priceRegionId

		if defaultProductData
			return {
				cost_price: defaultProductData.cost_price
				retail_price: defaultProductData.retail_price
			}

		return do @getEmptyPlaceholders

	getDefaultProductDataForPriceRegion: (productData, priceRegionId) ->
		for productDataItem in productData
			if (
				productDataItem.price_region_id == priceRegionId and
					(
						productDataItem.entity_type == null or
						productDataItem.entity_type == @defaultEntityType
					)
			)
				return productDataItem
		return null

	getParentPlaceholders: ->
		if @parentPlaceholders and angular.isDefined(@parentPlaceholders[@currentPriceRegionId])
			return @parentPlaceholders[@currentPriceRegionId]

		if not @parent
			return do @getEmptyPlaceholders

		@parentPlaceholders = {}

		angular.forEach _.groupBy(@parent.product_data, 'price_region_id'), (productDataItems, priceRegionId) =>
			@parentPlaceholders[priceRegionId] = @getPlaceholdersForPriceRegion productDataItems, priceRegionId

		if angular.isDefined @parentPlaceholders[@currentPriceRegionId]
			return @parentPlaceholders[@currentPriceRegionId]

		return do @getEmptyPlaceholders

	getCurrentPlaceholders: ->
		return @getPlaceholdersForPriceRegion do @getCurrentProductDataItems, @currentPriceRegionId

	getCurrentProductDataItems: (withDataOnly = false) ->
		productData = _.map @currentProductData, (productDataItem) ->
			return {
				cost_price: productDataItem.data?.cost_price
				retail_price: productDataItem.data?.retail_price
				entity_type: productDataItem.entityType
				price_region_id: productDataItem.priceRegionId
				original_price: productDataItem.original_price
			}

		if not withDataOnly
			return productData

		return _.reject productData, {data: null}

	onPriceRegionChange: (isPriceDefined) ->
		@selectPriceRegionGroup(isPriceDefined)

		do @matchBackProductData
		do @setCurrentProductData

	onPriceChange: ->
		do @setPlaceholders
		do @calculateGrossMargins

	setCurrentProductData: (priceRegionId = @currentPriceRegionId) ->
		@currentProductData = @getProductDataForPriceRegion priceRegionId
		@setPlaceholders()
		@calculateGrossMargins()
		@orderByEntityType()

	orderByEntityType: ->
		@currentProductData.sort (a, b) =>
			if a.entityType == @defaultEntityType
				return -1

			if b.entityType == @defaultEntityType
				return 1

			return 0

	##
	# Get product data that belongs to currently selected price region
	##
	getProductDataForPriceRegion: (priceRegionId) ->
		priceRegionProductData = []
		productDataTypes = @getProductDataTypes()

		angular.forEach productDataTypes, (type) =>
			productDataItem = _.find @productData, {entity_type: type.entity_type, price_region_id: priceRegionId}
			productDataItem = null if angular.isUndefined productDataItem

			priceRegionProductData.push {
				priceRegionId: priceRegionId
				typeName: type.name
				entityType: type.entity_type
				data: productDataItem
			}

		return priceRegionProductData

	##
	# Move UI model back to initial productData array
	##
	matchBackProductData: ->
		angular.forEach @currentProductData, (currentItem) =>
			productDataItem = _.find @productData, {entity_type: currentItem.entityType, price_region_id: currentItem.priceRegionId}

			if !currentItem.data
				# Item was removed
				@productData = _.without(@productData, productDataItem) if productDataItem

				return

			if productDataItem
				productDataItem = angular.extend {}, productDataItem, currentItem.data
			else
				@productData.push currentItem.data

	removeProductData: (index) ->
		if @currentProductData[index].entityType == @DEFAULT_PRODUCT_DATA_LABEL
			@switchPriceRegionGroup(@priceRegionsWithPrice, @priceRegionsWithoutPrice, false)

			for productDataItem in @currentProductData
				productDataItem.data = null
		else
			@currentProductData[index].data = null

		do @setPlaceholders
		do @calculateGrossMargins

	addProductData: (index) ->
		useCostPrice = @isProduct && @currentProductData[index].entityType == @BACKEND_PRODUCT_DATA_ENTITY_TYPE.PRODUCT_DATA

		if !_.isEmpty(@currentPriceRegionWithoutPriceId)
			@switchPriceRegionGroup(@priceRegionsWithoutPrice, @priceRegionsWithPrice, true)

		@currentProductData[index].data =
			entity_type: @currentProductData[index].entityType,
			price_region_id: @currentProductData[index].priceRegionId
			cost_price: if useCostPrice then 0 else null
			retail_price: if @isProduct then 0 else null
			original_price: null
			vat_rate_id: null

	groupPriceRegions: ->
		groupedProductData = _.groupBy(@product.product_data, (item) -> item.price_region_id)

		@priceRegionsWithPrice = []
		@priceRegionsWithoutPrice = []

		for priceRegion in @priceRegions
			if _.isEmpty(groupedProductData[priceRegion.id])
				@priceRegionsWithoutPrice.push(priceRegion)

				continue

			@priceRegionsWithPrice.push(priceRegion)

	selectPriceRegionGroup: (isPriceDefined) ->
		if isPriceDefined
			@currentPriceRegionId = @currentPriceRegionWithPriceId
			@currentPriceRegionWithoutPriceId = null
		else
			@currentPriceRegionId = @currentPriceRegionWithoutPriceId
			@currentPriceRegionWithPriceId = null

	switchPriceRegionGroup: (currentGroupPriceRegions, nextGroupPriceRegions, isPriceDefined) ->
		currentPriceRegionIndex = _.findIndex(currentGroupPriceRegions, (item) => item.id == @currentPriceRegionId)

		if currentPriceRegionIndex == -1
			return

		currentPriceRegion = currentGroupPriceRegions[currentPriceRegionIndex]

		currentGroupPriceRegions.splice(currentPriceRegionIndex, 1)
		insertAt = _.findIndex(nextGroupPriceRegions, (item) -> currentPriceRegion.name < item.name)

		if insertAt != -1
			nextGroupPriceRegions.splice(insertAt, 0, currentPriceRegion)
		else
			nextGroupPriceRegions.push(currentPriceRegion)

		@switchPriceRegion(isPriceDefined)

	switchPriceRegion: (isPriceDefined) ->
		if isPriceDefined
			@currentPriceRegionWithPriceId = @currentPriceRegionWithoutPriceId
			@currentPriceRegionWithoutPriceId = null
		else
			@currentPriceRegionWithoutPriceId = @currentPriceRegionWithPriceId
			@currentPriceRegionWithPriceId = null
